import OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';
import sessionStore from 'owa-session-store/lib/store/store';
import { getWhitelistedSessionDataSettings } from '../getWhitelistedSettings';
import { SettingsMetaData } from '../schema/SettingsMetaData';

const whitelistedSessionDataSettings = getWhitelistedSessionDataSettings();

type FilteredUserConfiguration = FilteredType<
    OwaUserConfiguration,
    typeof whitelistedSessionDataSettings,
    SettingsMetaData
>;

type FilteredType<Base, Selector, LeafType> = {
    [Key in keyof Selector]: Key extends keyof Base
        ? Selector[Key] extends LeafType
            ? Base[Key]
            : FilteredType<Base[Key], Selector[Key], LeafType>
        : never;
};

/**
 * Returns user configuration
 */
export function getFilteredUserConfiguration(): FilteredUserConfiguration {
    const userConfig = sessionStore.userConfiguration;

    return <FilteredUserConfiguration>userConfig;
}
